export default function (string) {
  if (!string?.length) return {};

  const selectedFilters = {};
  const filterStrings = string.split("&");

  for (const string of filterStrings) {
    const splitString = string.split("=");
    const key = splitString[0];

    selectedFilters[key] = splitString[1].split(",");
  }

  return selectedFilters;
}
